// extracted by mini-css-extract-plugin
export default {"pageWrapper":"ComingSoonSocialPage_pageWrapper__NL37C","cinematicBounce":"ComingSoonSocialPage_cinematicBounce__BdytM"};